var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 3.21484C14.4933 3.21484 18.2317 6.44798 19.0154 10.7148C18.2317 14.9817 14.4933 18.2148 9.99993 18.2148C5.50644 18.2148 1.76813 14.9817 0.984375 10.7148C1.76813 6.44798 5.50644 3.21484 9.99993 3.21484ZM9.99993 16.5482C13.5296 16.5482 16.5499 14.0915 17.3144 10.7148C16.5499 7.3382 13.5296 4.88151 9.99993 4.88151C6.47018 4.88151 3.44986 7.3382 2.68533 10.7148C3.44986 14.0915 6.47018 16.5482 9.99993 16.5482ZM9.99993 14.4648C7.92883 14.4648 6.24989 12.7859 6.24989 10.7148C6.24989 8.64378 7.92883 6.96484 9.99993 6.96484C12.0709 6.96484 13.7499 8.64378 13.7499 10.7148C13.7499 12.7859 12.0709 14.4648 9.99993 14.4648ZM9.99993 12.7982C11.1505 12.7982 12.0833 11.8654 12.0833 10.7148C12.0833 9.56426 11.1505 8.63151 9.99993 8.63151C8.84934 8.63151 7.91656 9.56426 7.91656 10.7148C7.91656 11.8654 8.84934 12.7982 9.99993 12.7982Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/open-eye-icon.e1b41fe80f4e2aad8c746bac8ebb3192.svg";
export { ForwardRef as ReactComponent };